import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { load, loadPreview } from '../../store/composition/composition.js';
import '../buttons/sdb-composition-start-button.js';
import '../buttons/sdb-composition-split-button.js';
import '../composition/sdb-composition-status.js';
import { compositionTypes } from '../../store/composition/helpers.js';

@customElement('sdb-composition-player-header')
class SdbCompositionPlayerHeader extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor compositionId = undefined;

    @property({type: String})
    accessor catalogName

    @property({ type: String })
    accessor sessionId = undefined;

    @property({ type: String })
    accessor type = undefined;

    @property({ type: Boolean })
    accessor preview = false;

    @property({ type: Boolean })
    accessor startDisabled = false;

    @property({ type: Boolean })
    accessor hideHeaderButtons;

    @property({ type: Boolean })
    accessor resetDisabled = false;

    @property({ type: Boolean })
    accessor resetHidden = false;

    @property({ type: Boolean })
    accessor light = false;

    @property({ type: Boolean })
    accessor small = false;

    @property({ type: Boolean })
    accessor compressed = false;

    @state()
    accessor composition = undefined;

    @state()
    accessor isLoading = false;

    stateChanged(state) {
        this.composition = state.composition.data;
        this.state = state.composition.data;
        this.isLoading = state.composition.status === 'loading' || !state.composition.data;
    }

    static get styles() {
        return css`
            :host {
            }

            .buttons {
                display: flex;
                justify-content: right;
                padding-right: 35px;
                padding-bottom: 35px;
            }

            :host([small]) .buttons {
                padding-right: 0;
                padding-bottom: 0;
            }

            sdb-composition-reset-button {
                margin-left:10px;
            }

            sdb-composition-reset-button[hidden] {
                display: none;
            }
        `;
    }

    render() {
        if (!this.composition) {
            return nothing;
        }

        return html`
            <sdb-composition-status
                .composition=${this.composition}
                ?light=${this.light}
                ?small=${this.small}
                ?compressed=${this.compressed}>
            </sdb-composition-status>

            ${!this.hideHeaderButtons ? html`
                <div class="buttons">
                    ${this.resetHidden ? html`
                            <sdb-composition-start-button
                                ?disabled=${this.startDisabled}
                                ?light=${this.light}>
                            </sdb-composition-start-button>
                        ` : html`
                            <sdb-composition-split-button
                                ?startDisabled=${this.startDisabled}
                                ?resetDisabled=${this.resetDisabled}
                                ?hidden=${this.resetHidden}
                                catalogName=${this.catalogName}
                                ?light=${this.light}>
                            </sdb-composition-split-button>
                        `
                    }
                </div>`: nothing
            }
        `;
    }

    firstUpdated() {
        if (this.preview) {
            store.dispatch(loadPreview({
                compositionId: this.compositionId,
                type: this.type,
            }));
            return;
        }
        store.dispatch(load({
            compositionId: this.compositionId,
            sessionId: this.sessionId,
        }));
    }

    updated() {
        if (!this.composition)
            return;

        this.dispatchEvent(new CustomEvent('updated', {
            bubbles: true,
            composed: true,
            detail: {
                targetId: this.composition.uniqueId,
                isSingleItem: this.composition.compositionType === compositionTypes.COMPOSITIONTYPE_SINGLEITEM,
                progress: this.composition.progress,
                success: this.composition.success,
                score: this.composition.score,
            }
        }));
    }
}
